import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { ActivatedRoute ,Router } from "@angular/router";
import { ProductModelServer, ServerResponse } from 'src/app/models/product.model';
import { CartService } from "../../services/cart.service";
import { environment } from 'src/environments/environment';
import { CategoryService } from 'src/app/services/category.service';

import { BannerService } from "../../services/banner.service";
import { Banner } from 'src/app/models/banners';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnInit {

  banners: Banner[] = [];
  isBannerLoading = false;
  bannerError = false;
  BannerUrl = environment.BannerUrl;
  imageBaseUrl = environment.imageBaseUrl;
  otherimageBaseUrl = environment.otherimageBaseUrl;
  products: ProductModelServer[] = [];
  categories: any[] = [];
  searchQuery = '';
   @ViewChild('searchResultsSection') searchResultsSection: ElementRef;
  
  constructor(private productService: ProductService,
    private router: Router,
    private cartService: CartService,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private bannerService: BannerService) { }
    
  ngOnInit(): void {

      this.loadBanners();
      
    // Fetch products
    // Check for search query
    this.route.queryParams.subscribe(params => {
      const query = params['q'];

      if (query) {
        this.productService.searchProducts(query).subscribe((res: any) => {
          this.products = res.products;
          
          if (Array.isArray(this.products) && this.products.length > 0)  {
            //console.log('kfeufhu',this.products);
            // Smooth scroll to result section after short delay
            setTimeout(() => {
              this.searchResultsSection?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
            }, 5000); // 300ms is a good UX delay
          }
        }, error => {
          this.products = [];
        });
      } else {
        // Load all products (default view)
        this.productService.getAllProducts().subscribe((prods: ServerResponse) => {
          this.products = prods.products.slice(0, 6);
        });
      }
    });


    // Fetch categories
    this.categoryService.getCategories().subscribe((data: any[]) => {
      this.categories =  data.slice(0, 3);
    });
  }


  loadBanners(): void {
    this.isBannerLoading = true;
    this.bannerError = false;

    this.bannerService.getBanners().subscribe({
      next: (res) => {
        this.banners = res || [];
        this.isBannerLoading = false;
      },
      error: (err) => {
        console.error('Banner loading failed', err);
        this.isBannerLoading = false;
        this.bannerError = true;
      }
    });
  }


  onSearchChange(query: string) {
    this.searchQuery = query;

    if (query.length > 1) {
      this.router.navigate(['/home'], { queryParams: { q: query } });
    }
  }

  selectProduct(id: Number) {
    this.router.navigate(['product', id]).then();
  }


  selectCategory(id: Number) {
    this.router.navigate(['category', id]).then();
  }


  AddToCart(id: number) {
    this.cartService.AddProductToCart(id);
  }


  // Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
  getSlug(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }
}
